<template>

  <DashboardLayout :menu-items="dashboardMenu">
    <dashboard-mobile-profile/>
    <div class="text-dashboard  w-100 h-auto">

      <m-update-site-message-1/>


      <h3> دسترسی سریع:</h3>

      <div class="container-fluid">
        <div class="row">


          <b-col lg="3" class="mt-3">
            <router-link class="text-decoration-none" :to="{name:'Profile'}">

              <b-card class="text-center">
                <b-card-title>
                  <b-icon icon="emoji-sunglasses"></b-icon>
                </b-card-title>
                <b-card-text>
                  پروفایل
                </b-card-text>
              </b-card>
            </router-link>
          </b-col>

          <b-col lg="3" class="mt-3">
            <router-link class="text-decoration-none" :to="{name:'Home'}">

              <b-card class="text-center">
                <b-card-title>
                  <b-icon icon="house"></b-icon>
                </b-card-title>
                <b-card-text>
                  بازگشت به سایت
                </b-card-text>
              </b-card>
            </router-link>
          </b-col>

          <b-col lg="3" class="mt-3">
            <router-link class="text-decoration-none" :to="{name:'messenger'}">

              <b-card class="text-center">
                <b-card-title>
                  <b-icon icon="signpost2-fill"></b-icon>
                </b-card-title>
                <b-card-text>
                  چت های من
                </b-card-text>
              </b-card>
            </router-link>
          </b-col>

          <b-col lg="3" class="mt-3">
            <router-link class="text-decoration-none" :to="{name:'WishListUser',params:{user:profile.id}}">

              <b-card class="text-center">
                <b-card-title>
                  <b-icon icon="heart-fill"></b-icon>
                </b-card-title>
                <b-card-text>
                  لیست موردعلاقه ها
                </b-card-text>
              </b-card>
            </router-link>
          </b-col>


          <div class="mt-5 w-100" v-if="findAttributeOnSiteInfo('show_users_orders_in_main_dashboard')[0] == 1">
            <Orders class="col-12"/>
          </div>

          <b-container class="mt-5">
            <UserCourse/>
          </b-container>

        </div>
      </div>

    </div>

  </DashboardLayout>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {dashboardMenu} from '../../routes/DashboardRoutes'
import DashboardLayout from '../../components/dashboard/Layout'
import Orders from '../dashboard/orders'
import UserCourse from "../../components/dashboard/Course/UserCourse";
import DashboardMobileProfile from "../../components/dashboard/DashboardMobileProfile";

export default {
  name: "Dashboard",
  components: {DashboardLayout, Orders, UserCourse, DashboardMobileProfile},
  data() {
    return {
      dashboardMenu
    }
  },
  computed: {
    ...mapGetters({
      profile: "User/getProfile"
    })
  },
  methods: {
    ...mapActions({
      logout: "Authentication/logout",
    }),
  }

};
</script>

<style scoped>
.text-dashboard {
  width: 95%;
  height: auto;
  background: #fafbf8;
  margin: auto;
  border-radius: 5px;
  padding: 10px;
}

.inventory {
  font-size: 80%;
}

.my-dashboard {
  width: 100%;
  height: 80px;
  background: white;
  border-radius: 5px;
}

.profile-fixed {
  width: 50px;
  height: 50px;
  margin-right: 50px;
}

.text-dashboard {
  width: 95%;
  height: auto;
  background: #fafbf8;
  margin: auto;
  border-radius: 5px;
}

#lblCartCount {
  font-size: 12px;
  background: #ff0000;
  color: #fff;
  padding: 0 5px;
  vertical-align: top;
  margin-left: -10px;
  margin-top: 0px;
}

.bell-big {
  width: 30px;
  height: 20px;
}


</style>